import Page from "../../../modules/Core/Components/Page";
import templateDefault from "../../templates/default/pages/men";

export default class Men extends Page {
  template = templateDefault;

  onAuth() {
    this.refresh();
  }

  onLoad(data) {
    super.onLoad(data);
    this.getApp().updateWindowTitle(
      `${this.ucfirst("Men's")} | ${this.ucfirst("window-title")}`
    );
  }
}
